export type ApplicationLoader = () => Promise<unknown>

/**
 * Deliberate local copy of the canonical shared-types constant. Importing the
 * package here would pull the support matrix and its schema dependencies into
 * the tiny pre-application bootstrap. A regression test pins this copy to the
 * canonical value.
 */
export const BOOT_BLOCK_ATTRIBUTE_COPY = 'data-coach-unsupported-browser'

/**
 * Load the application only when the ES5 syntax-floor shim did not block
 * this browser. This runs before the real entry module is imported, so a
 * below-floor browser cannot initialize Sentry or let React overwrite the
 * static recovery guidance even when a particular bundle happens to parse.
 */
export async function loadApplicationIfSupported(
  root: Element | null,
  loadApplication: ApplicationLoader,
): Promise<boolean> {
  if (!root) throw new Error('Root element not found')
  if (root.hasAttribute(BOOT_BLOCK_ATTRIBUTE_COPY)) return false

  await loadApplication()
  return true
}
